import React from "react";
import { Paper, Stack, Group, Text, ThemeIcon, Title } from "@mantine/core";
import { IconX, IconBolt } from "@tabler/icons-react";

interface PaymentFailedNotificationProps {
  title: string;
  satoshis: number;
  fiat: string;
  onClick: () => void;
}

const PaidFailureNotificationDesign = ({
  title,
  satoshis,
  fiat,
  onClick,
}: PaymentFailedNotificationProps) => (
  <Paper
    p={32}
    radius="md"
    shadow="md"
    onClick={onClick}
    style={{ background: "#000", position: "relative", cursor: "pointer" }}
  >
    <Stack align="center" gap={16}>
      <ThemeIcon radius="xl" size={160} style={{ background: "transparent" }}>
        <IconX color="#FF4D4D" size={160} stroke={4} /> {/* red cross */}
      </ThemeIcon>

      <Title order={2} c="white">
        {title}
      </Title>

      <Group gap={6}>
        <IconBolt size={28} color="#FFD700" />
        <Text size="xl" fw={700} c="white">
          {satoshis.toLocaleString()}
        </Text>
      </Group>

      <Text size="lg" c="gray.4">
        {fiat}
      </Text>
      <Text size="sm" c="gray.5" mt={24}>
        Try sending a smaller amount, or try this payment from a different
        application.
      </Text>

      <Text size="sm" c="gray.5" mt={24}>
        Tap anywhere to continue
      </Text>
    </Stack>
  </Paper>
);

export default PaidFailureNotificationDesign;
